import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Component from "./component";
import { setActiveAccordionStepIndex, setFormActiveScreen } from "../pre-delivery-inspection-lead-form-parent/actions";

const mapStateToProps = ({
    preDeliveryInspectionLeadData,
    user: {isLoggedIn}
}) => ({
    preDeliveryInspectionLeadData,
    isLoggedIn
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setFormActiveScreenConnect: setFormActiveScreen,
    setActiveAccordionStepIndexConnect: setActiveAccordionStepIndex
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Component);
